import "babel-polyfill";
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import App from './App.vue';
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './assets/css/style.css'
import rem from './assets/js/rem'

Vue.use(vueSwiper)

import {
  Button,
  Menu,
  Submenu,
  MenuItem,
} from 'element-ui';
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Menu)
Vue.use(Button)
rem()
import Function from './function/index'
Vue.prototype.$Func = Function
// router.beforeEach((to, from, next) => {

// });
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});